import React, { useEffect, useState } from "react";
import { marked } from "marked";
import { FileText, ShieldCheck, BookOpen } from "lucide-react";
import { listDocs, getDoc } from "../lib/api";
import { sanitize } from "../lib/sanitize";

marked.setOptions({ gfm: true, breaks: false });

const ICONS = { technical: ShieldCheck, "sdk-guide": BookOpen };

export function DocsViewer() {
  const [docs, setDocs] = useState(null);
  const [active, setActive] = useState(null);
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    listDocs().then((list) => {
      setDocs(list);
      if (list && list.length) setActive(list[0].slug);
    }).catch(() => setDocs([]));
  }, []);

  useEffect(() => {
    if (!active) return;
    setLoading(true);
    getDoc(active)
      .then((d) => setHtml(sanitize(marked.parse(d.markdown || ""))))
      .catch(() => setHtml("<p>Could not load this document.</p>"))
      .finally(() => setLoading(false));
  }, [active]);

  if (docs === null) return <div className="docs-empty" data-testid="docs-loading">Loading documentation…</div>;
  if (!docs.length) return <div className="docs-empty" data-testid="docs-empty">No documents are available for your account yet.</div>;

  return (
    <div className="docs-wrap" data-testid="docs-viewer">
      <aside className="docs-list">
        {docs.map((d) => {
          const Icon = ICONS[d.slug] || FileText;
          return (
            <button
              key={d.slug}
              className={`docs-list-item ${active === d.slug ? "active" : ""}`}
              onClick={() => setActive(d.slug)}
              data-testid={`docs-item-${d.slug}`}
            >
              <Icon size={18} />
              <span>
                <b>{d.title}</b>
                <em>{d.desc}</em>
              </span>
              {d.audience === "admin" && <span className="docs-tag">Admin</span>}
            </button>
          );
        })}
      </aside>
      <article className="docs-body" data-testid="docs-content">
        {loading ? <div className="docs-empty">Loading…</div>
          : <div className="md" dangerouslySetInnerHTML={{ __html: html }} />}
      </article>
    </div>
  );
}

export default DocsViewer;
